<template>
  <div
    :class="[
      'JoszakiToast',
      'flex',
      'justify-center',
      'items-center',
      '!px-2',
      'sm:!px-4',
      '!py-1',
      'sm:!py-3',
      'rounded-md',
      'border',
      'shadow-md',
      {
        'text-white': type !== 'warning',
        'bg-info border-info-darker': type === 'info',
        'bg-success border-success-darker': type === 'success',
        'bg-warning text-black border-warning-darker': type === 'warning',
        'bg-danger border-danger-darker': type === 'danger',
        'bg-error border-error-darker': type === 'error',
      },
    ]"
  >
    <IconComponent
      :icon="icon"
      class="mr-2 sm:mr-4 !text-base sm:!text-xl min-w-[20px]"
    />
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-html="message" />
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "success",
    },
    message: {
      type: String,
      default: "asdasd",
    },
  },
  computed: {
    icon() {
      if (!this.type) {
        return undefined;
      }
      switch (this.type) {
        case "success":
          return "check-circle";
        case "warning":
          return "exclamation-triangle";
        case "error":
        case "danger":
          return "times-circle";
        default:
          return "info-circle";
      }
    },
  },
};
</script>
